// Medical's shared pure logic — extracted out of Medical.js (2026-09-10) so MedicalPanel.js (the
// Einstein compose panel) reuses the exact same stage metadata instead of a second hand-copy
// silently drifting from the full page. Same extraction pattern as gps/matchChronicShared.js.
import { getPlayers, getInjuries, getIllnesses } from '../api';

// RTP removed (confirmed 2026-07-28) — RTC is now the final stage and inherits RTP's old
// role as the closing trigger (see Medical.js's "Close (RTC)" button and the backend's
// PUT /api/injuries/:id/stage, which sets is_closed on reaching 'rtc').
export const STAGES = [
  { id: 'medical_rehab', label: 'Medical Rehab', color: '#ef4444' },
  { id: 'ofr',           label: 'OFR',           color: '#f59e0b' },
  { id: 'rtt',           label: 'RTT',            color: '#8b5cf6' },
  { id: 'rtc',           label: 'RTC',            color: '#10b981' },
];

export function stageMeta(id) { return STAGES.find(s => s.id === id) || STAGES[0]; }

export function daysSince(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  return Math.floor((Date.now() - d.getTime()) / 86400000);
}

export function fmtDate(d) {
  if (!d) return '—';
  const dt = new Date(d);
  return dt.toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: '2-digit' });
}

// The shared reference-data fetch MedicalPanel.js's props expect — one team-wide fetch of
// injuries/illnesses feeding N per-player panels, same "fetch once, render many" pattern as
// gps/matchChronicShared.js's fetchMatchChronicPanelData. Unfiltered (no player_id query param)
// deliberately — a compose request typically names 2+ players, so one team-wide fetch is cheaper
// than N per-player round trips, same reasoning as the GPS panel's shared allMatchDrills fetch.
export async function fetchMedicalPanelData() {
  const [players, injuries, illnesses] = await Promise.all([getPlayers(), getInjuries(), getIllnesses()]);
  return { players: players || [], injuries: injuries || [], illnesses: illnesses || [] };
}
